import { render, staticRenderFns } from "./ProductionBase.vue?vue&type=template&id=1c810f69&scoped=true"
import script from "./ProductionBase.vue?vue&type=script&lang=js"
export * from "./ProductionBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c810f69",
  null
  
)

export default component.exports